module.exports = __webpack_public_path__ + "static/media/xz04_grey.b2d714d4.png";